export default "__VITE_ASSET__BPKFOe4s__"